module.exports = __webpack_public_path__ + "media/images/steps/svg/182-promotion-3-c5b2069803f6f4b413e8473647a846dd.svg";